<template>
    <div class="mpS2">
        <div class="mpS2-text1">판.매.수.수.료</div>
        <div class="mpS2-text1">앱.내.외.홍.보</div>
        <div class="mpS2-text1">라.이.브.방.송</div>
        <div class="mpS2-text2">0%</div>
        <div class="mpS2-text3">입점사와 함께 성장하기 위해 ON STYLE LIVE에 입점하는 모든 입점사는 판매수수료,앱내외홍보비용,라이브방송비용 모두 무료입니다.</div>
    </div>
</template>
<script>
export default {
    name: "mpSlide2"
}
</script>
<style lang="scss" scoped>
.mpS2 {
 width: 100%;
 padding: 50px 15px 50px 15px;
 box-sizing: border-box;
 background-size: 30px 30px;
 background-image: repeating-radial-gradient(white 0px, #f5f0e7 2px, #f5f0e7 48px);
 text-align: center;
 position: relative;
 .mpS2-text1 {
     font-size: 5.5vh;
     font-weight: 900;
     color: #a8a296;
     margin-bottom: 20px;
 }
 .mpS2-text2{
     font-size: 15vh;
     font-weight: 900;
     color: #ff5c5c;
     margin-bottom: 20px;
 }
 .mpS2-text3{
     color: #948e82;
     font-size: 2vh;
 }
}
</style>